import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelayCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.017 0h-.034a6 6 0 1 0 .034 0Zm0 10.857a4.857 4.857 0 0 1-.034-9.714V6l3.49-3.407a4.86 4.86 0 0 1-3.456 8.264Z" })
});
export default SvgDelayCircle;
